﻿import { IconCheck, IconCrown } from '@tabler/icons-react';
type RoomPlayer = {
  id: string;
  name: string;
  score?: number;
  unverified?: number;
  answeredAt?: number | null;
  ready?: boolean;
  place?: number;
};
import classes from './room-player-list.module.css';

type Props = {
  players: readonly RoomPlayer[];
  selfId?: string;
  ranked?: boolean;
  showScores?: boolean;
  showAnswers?: boolean;
  showReadiness?: boolean;
};

export const RoomPlayerList = ({ players, selfId, ranked, showScores, showAnswers, showReadiness }: Props) => (
  <ol className={classes.list} aria-label={ranked ? 'Таблица результатов' : 'Игроки комнаты'}>
    {players.map((player, index) => (
      <li className={classes.player} key={player.id} data-self={player.id === selfId || undefined}>
        {ranked && (
          <span className={classes.rank}>
            {(player.place ?? index + 1) === 1 ? (
              <IconCrown size={22} aria-label="Первое место" />
            ) : (
              (player.place ?? index + 1)
            )}
          </span>
        )}
        <span className={classes.avatar} aria-hidden="true">
          {player.name.slice(0, 1).toLocaleUpperCase('ru-RU')}
        </span>
        <span className={classes.name}>
          {player.name}
          {player.id === selfId && <small>это вы</small>}
        </span>
        {ranked || showScores ? (
          <span className={classes.score}>
            <strong>{player.unverified ? '—' : (player.score ?? 0).toLocaleString('ru-RU')}</strong>
          </span>
        ) : showAnswers ? (
          <span className={classes.status}>
            {typeof player.answeredAt === 'number' ? (
              <>
                <IconCheck size={18} aria-hidden="true" />
                Ответил
              </>
            ) : (
              'Думает…'
            )}
          </span>
        ) : showReadiness ? (
          <span className={classes.status} data-ready={player.ready || undefined}>
            {player.ready && <IconCheck size={18} aria-hidden="true" />}
            {player.ready ? 'Готов' : 'Не готов'}
          </span>
        ) : (
          <IconCheck size={18} className={classes.ready} aria-label="В комнате" />
        )}
      </li>
    ))}
  </ol>
);
